import React from 'react';
import { styled } from '@compiled/react';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import Button from '@atlaskit/button';

import type { TriggerProps } from '@atlaskit/popup';

type PickerTriggerProps = {
	triggerProps: TriggerProps;
	displayText: string;
	onClick: (e: React.MouseEvent | React.KeyboardEvent) => void;
	isOpen: boolean;
	shouldFitContainer?: boolean;
	ariaLabel: string;
};

const PickerTrigger = ({
	triggerProps,
	displayText,
	onClick,
	isOpen,
	shouldFitContainer = false,
	ariaLabel,
}: PickerTriggerProps) => (
	<StyledTriggerButton
		{...triggerProps}
		iconAfter={<ChevronDownIcon spacing="spacious" label="" size="small" />}
		onClick={onClick}
		shouldFitContainer={shouldFitContainer}
		aria-label={ariaLabel}
		aria-expanded={isOpen}
		aria-haspopup="listbox"
	>
		{displayText}
	</StyledTriggerButton>
);

export default PickerTrigger;

/*
 * Use of jira-jql-builder-basic-picker requires a trigger to be provided as a prop. In jql-builder,
 * atlaskit/button is used as a trigger. However our design spec is based on an atlaskit/select which
 * left aligns text on the trigger. This workaround is left aligning the text so that it looks more
 * like an atlaskit/select trigger.
 * This also restricts us to using legacy button as button/new does not work with `styled()`
 * TODO - https://jplat.jira.atlassian.cloud/browse/EM-7822
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
const StyledTriggerButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
	textAlign: 'left !important',
});
